module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Plato\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Plato (428−348 BCE) was a philosopher and mathematician in ancient Greece. A student of Socrates and a teacher of Aristotle, his Academy was one of the first institutions of higher learning in the Western world. He is widely regarded as the father of modern philosophy. "), _c('BR')], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/l356OP/tc-custom/9781504052207.jpg?1718183630760",
      "alt": "This image is the cover for the book Symposium"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Symposium\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A fascinating discussion on sex, gender, and human instincts by one of history’s greatest philosophers.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" In the course of a lively drinking party, a group of Athenian intellectuals exchange views on desire. From their conversation emerges a series of subtle reflections on gender roles, sex in society, and basic human instincts. The debate precedes one great after another: Agathon, Aristodemus, Eryximachus, Pausanias, Aristophanes, and Socrates—all describing love in many possible permutations and combinations. The dialogue culminates in a radical challenge to conventional views by Plato’s mentor, Socrates, who advocates transcendence through spiritual love. "), _c('i', [_vm._v("The Symposium")]), _vm._v(" is a deft interweaving of different viewpoints and ideas about the nature of love.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0